module.exports = __webpack_public_path__ + "static/img/3.4f9a28a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/zh/3.png
// module id = e+ir
// module chunks = 0